// Layout Configuration Constants
export const LAYOUT_CONFIG = {
  // Main layout styling
  MAIN: {
    container: 'min-h-screen bg-gray-50 flex flex-col',
    content: 'flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8',
    centerContainer: 'sm:mx-auto sm:w-full sm:max-w-md',
    cardContainer: 'mt-8 sm:mx-auto sm:w-full sm:max-w-md'
  },
  
  // Typography
  TYPOGRAPHY: {
    title: 'text-3xl font-extrabold text-gray-900',
    subtitle: 'mt-2 text-sm text-gray-600',
    textCenter: 'text-center'
  },
  
  // Page layout styling
  PAGE: {
    container: 'min-h-screen bg-gray-50',
    headerBg: 'bg-white shadow',
    headerContainer: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
    mainContainer: 'max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'
  },
  
  // Card styling
  CARD: {
    content: 'py-8'
  },
  
  // Alert styling
  ALERT: {
    container: 'mb-6'
  },
  
  // Responsive breakpoints
  RESPONSIVE: {
    maxWidth: {
      sm: 'sm:max-w-md',
      md: 'md:max-w-lg',
      lg: 'lg:max-w-xl',
      xl: 'xl:max-w-2xl'
    },
    padding: {
      mobile: 'px-4',
      tablet: 'sm:px-6',
      desktop: 'lg:px-8'
    },
    margin: {
      auto: 'mx-auto',
      top: {
        sm: 'mt-2',
        md: 'mt-4',
        lg: 'mt-8'
      }
    }
  }
};
